/* eslint-disable no-irregular-whitespace */
import { ButtonProps, IconProps } from '@chakra-ui/react';
import Button from '~/components/Button';
import IconButton from '~/components/IconButton';
import { DownloadPdfIcon } from '~/components/icons';
import { useBreakpointValue } from '~/utils-ts';

interface Props extends ButtonProps {
  buttonText?: string;
  iconProps?: IconProps;
}

export const ExportPdfButton: React.FC<Props> = ({
  buttonText = 'One Sheet PDF',
  iconProps = {} as IconProps,
  isDisabled = false,
  onClick,
  ...props
}) => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  if (isMobile) {
    return (
      <IconButton
        aria-label="Download PDF media pack"
        colorScheme="neutral"
        // @ts-ignore
        icon={<DownloadPdfIcon {...iconProps} />}
        isDisabled={isDisabled}
        isRound
        onClick={isDisabled ? undefined : onClick}
        size="sm"
        variant="outline"
        {...props}
      />
    );
  }

  return (
    <Button
      colorScheme="neutral"
      fontWeight="medium"
      // @ts-ignore
      leftIcon={<DownloadPdfIcon {...iconProps} />}
      onClick={isDisabled ? undefined : onClick}
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      rounded="full"
      size="sm"
      variant="outline"
      {...props}
    >
      {buttonText}
    </Button>
  );
};
